module.exports = __webpack_public_path__ + "img/console26.ca34aa5e.jpg";